import { Building2Icon, MapPinIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Text } from "@/components/Text";
import { dates } from "@/lib/dates";
import { EducationType } from "@/types";

export const Education = ({ education }: { education: EducationType }) => {
  /* Helpers */
  const dateDisplay =
    dates.prepareDateDisplayForCertificationOrEducationOrWorkExperience({
      startMonth: education.startMonth ?? undefined,
      startYear: education.startYear ?? undefined,
      endMonth: education.endMonth ?? undefined,
      endYear: education.endYear ?? undefined,
      current: education.current ?? undefined,
    });
  const degree = education.degree?.trim();
  const school = education.school?.trim();
  const hasLocation = !!education.location;

  /* Render */
  const render = () => {
    return (
      <Row className="items-start gap-4">
        <Row className="h-11 w-11 shrink-0 items-center justify-center rounded-lg border border-slate-200 bg-slate-50">
          <Building2Icon className="h-5 w-5 text-slate-400" />
        </Row>
        <Column className="min-w-0 flex-1 gap-0.5">
          <Row className="flex-wrap items-baseline gap-x-2">
            {degree ? (
              <Text className="text-sm font-medium text-slate-800">
                {degree}
              </Text>
            ) : (
              <Text className="text-sm font-medium italic text-red-400">
                [Missing Degree]
              </Text>
            )}
            <Text className="text-slate-500">·</Text>
            {school ? (
              <Text className="text-sm font-light text-slate-500">
                {school}
              </Text>
            ) : (
              <Text className="text-sm font-light italic text-red-400">
                [Missing School]
              </Text>
            )}
          </Row>
          {dateDisplay || hasLocation ? (
            <Row className="flex-wrap items-center gap-x-2 text-xs font-normal text-slate-500">
              {dateDisplay ? (
                <Text className="text-xs">{dateDisplay}</Text>
              ) : null}
              {dateDisplay && hasLocation ? (
                <Text className="text-slate-500">·</Text>
              ) : null}
              {hasLocation ? (
                <Row className="items-center gap-1">
                  <MapPinIcon className="h-3.5 w-3.5" />
                  <Text className="text-xs">{education.location}</Text>
                </Row>
              ) : null}
            </Row>
          ) : null}
        </Column>
      </Row>
    );
  };

  return render();
};
